import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { InfoPopupComponent } from './info-popup/info-popup.component';
import { ErrorPopupComponent } from './error-popup/error-popup.component';
import { WarningPopupComponent } from './warning-popup/warning-popup.component';
import { QuestionPopupComponent } from './question-popup/question-popup.component';

@NgModule({
  declarations: [
    InfoPopupComponent,
    ErrorPopupComponent,
    WarningPopupComponent,
    QuestionPopupComponent
  ],
  imports: [
    CommonModule,
    IonicModule,
    FormsModule,
    ReactiveFormsModule
  ],
  exports: [
    InfoPopupComponent,
    ErrorPopupComponent,
    WarningPopupComponent,
    QuestionPopupComponent
  ]
})
export class PopupModule { }